import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function FeaturedMovies() {
  const featured = movies.filter((m) => m.isHot).slice(0, 5);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
              <i className="ri-fire-line text-accent-400 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/movie"
            className="text-sm text-accent-400 hover:text-accent-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {featured.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg aspect-[2/3] mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  title={`秋霞影院 ${movie.title} 在线观看`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2 flex items-center gap-1.5">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {movie.quality}
                  </span>
                  {index === 0 && (
                    <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                      热播
                    </span>
                  )}
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-xs text-foreground-300 bg-background-50/80 px-1.5 py-0.5 rounded">
                    ★ {movie.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/90">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-100 group-hover:text-accent-400 transition-colors truncate">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                <span>{movie.year}</span>
                <span>·</span>
                <span>{movie.subtype}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}